module.exports = __webpack_public_path__ + "static/img/light.3beda8c6.svg";